import adminApi from "../axios";

function dataOf(response) {
  return response?.data?.data ?? response?.data ?? [];
}

function authConfig(extra = {}) {
  return {
    ...extra,
    headers: {
      ...extra.headers,
      Authorization: `Bearer ${localStorage.getItem("@token")}`,
    },
  };
}

export async function listOrganizations(params = {}) {
  return dataOf(await adminApi.get("organizations", authConfig({ params })));
}

export async function getOrganization(organizationId) {
  return dataOf(
    await adminApi.get(`organizations/${organizationId}`, authConfig())
  );
}

export async function createOrganization(payload) {
  return dataOf(await adminApi.post("organizations", payload, authConfig()));
}

export async function updateOrganization(organizationId, payload) {
  return dataOf(
    await adminApi.patch(`organizations/${organizationId}`, payload, authConfig())
  );
}

export async function listOrganizationGurus(organizationId, params = {}) {
  return dataOf(
    await adminApi.get(
      `organizations/${organizationId}/gurus`,
      authConfig({ params })
    )
  );
}

export async function addOrganizationGuru(organizationId, guruId) {
  return dataOf(
    await adminApi.put(
      `organizations/${organizationId}/gurus/${guruId}`,
      {},
      authConfig()
    )
  );
}

export async function removeOrganizationGuru(organizationId, guruId) {
  return dataOf(
    await adminApi.delete(
      `organizations/${organizationId}/gurus/${guruId}`,
      authConfig()
    )
  );
}

export async function listOrganizationCourses(organizationId) {
  return dataOf(
    await adminApi.get(
      "courses",
      authConfig({
        params: {
          provider_type: "ORGANIZATION",
          organization_id: organizationId,
        },
      })
    )
  );
}

export async function listAllGurus() {
  const users = dataOf(await adminApi.get("users", authConfig()));
  return Array.isArray(users)
    ? users.filter((user) => String(user.role).toLowerCase() === "guru")
    : [];
}
